<!--
	账单
	lovi 2020-1-3
-->
<template>
  <div>
    <div class="breadcrumb-wrap">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("common.eepay") }}</BreadcrumbItem>
        <BreadcrumbItem>{{ $t("wallet.billDetail") }}</BreadcrumbItem>
      </Breadcrumb>
      <a class="returnA" v-if="detailFlag || subOrderFlag" @click="returnFun">
        {{ $t("common.back") }}
      </a>
    </div>
    <!-- 列表 -->
    <div v-show="!detailFlag && !subOrderFlag">
      <search
        :typeFlag="true"
        :typeList="typeList"
        :payTypeFlag="true"
        :payTypeList="payTypeList"
        :dateFlag="true"
        @search="getSearch"
      ></search>

      <div class="list-wrap" v-if="listData.length">
        <div
          class="item-list"
          v-for="(item, index) in listData"
          :key="index"
          @click="toDetail(item)"
        >
          <div class="list-l">
            <img
              class="icon"
              :src="
                item.icon
                  ? httpUrl + item.icon
                  : require('@/assets/images/public/logo_icon@2x.png')
              "
            />
            <div>
              <h3>{{ item.type_name }}</h3>
              <p class="text-gray">{{ item.createtime }}</p>
            </div>
          </div>
          <div class="list-r">
            <h3>
              {{ item.money_type == 1 ? "+" : item.money_type == 2 ? "-" : "" }}
              {{ item.money }}
            </h3>
            <p class="text-blue">
              {{ item.status }}
            </p>
          </div>
        </div>
        <div class="page-wrap">
          <div class="total">
            <span>
              {{ $t("common.totalExpenditure") }}：{{ totalData.total_spend }}P
            </span>
            <span>
              {{ $t("common.totalIncome") }}：{{ totalData.total_revenue }}P
            </span>
          </div>
          <Page
            :total="totalData.num"
            @on-change="getPage(page)"
            :current.sync="page"
            size="small"
            show-total
          />
        </div>
      </div>
      <div class="no-data" v-else>
        <img
          :src="
            require('@/assets/images/public/no_data_' +
              (language == 'en' ? 'en' : 'cn') +
              '.png')
          "
        />
        <p>{{ $t("common.noData") }}</p>
      </div>
    </div>

    <!-- 详情 -->
    <detail
      v-if="detailFlag"
      :detailFlag.sync="detailFlag"
      :order_id="detail.order_id"
      :type="detail.type"
      @getSubOrder="getSubOrder"
    />

    <!-- 批量充值子订单充值记录 -->
    <sub-order v-if="subOrderFlag" :data="subOrderData" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { formatDate } from "@/commonJs";
import Search from "@/components/search";
import Detail from "@/components/detail";
import SubOrder from "@/components/detail/subOrder";
export default {
  name: "personal-bill",
  components: {
    Search,
    Detail,
    SubOrder
  },
  data() {
    return {
      startDate: formatDate(new Date()), //开始时间
      endDate: formatDate(new Date()), //结束时间
      type: "", // 交易类型
      typeList: [], // 交易类型列表
      payType: "", // 交易方式
      payTypeList: [], // 交易方式列表
      page: 1,
      listData: [],
      totalData: {}, // 统计数据

      detailFlag: false, // 详情页Flag
      detail: {}, // 详情Id
      subOrderFlag: false, // 子订单Flag
      subOrderData: {} // 子订单数据
    };
  },
  created() {
    this.billDetailsType();
    this.getMyAccountLog();
  },
  mounted() {},
  computed: {
    ...mapGetters(["language"])
  },
  methods: {
    billDetailsType() {
      // 账单明细类型
      let vm = this;
      vm.$post("/app/help/billDetailsType", {}, { loading: true }).then(res => {
        console.log("billDetailsType", res);
        vm.typeList = res.list;
        vm.payTypeList = res.pay_type;
      });
    },
    returnFun() {
      // 返回
      let vm = this;
      if (vm.subOrderFlag) {
        vm.detailFlag = true;

        vm.subOrderFlag = false;
        vm.subOrderData = {};
      } else {
        vm.detailFlag = false;
        vm.detail = {};

        vm.subOrderFlag = false;
        vm.subOrderData = {};
      }
    },
    getSubOrder(data) {
      // 获取子订单数据
      let vm = this;
      console.log("getSubOrder", data);
      vm.detailFlag = false;
      vm.subOrderFlag = true;
      vm.subOrderData = data;
    },
    getSearch(data) {
      //搜索
      let vm = this;
      vm.startDate = data.startDate;
      vm.endDate = data.endDate;
      vm.type = data.typeVal;
      vm.payType = data.payTypeVal;
      vm.page = 1;
      vm.getMyAccountLog();
    },
    getPage(page) {
      // 点击分页
      let vm = this;
      vm.page = page;
      vm.getMyAccountLog();
    },
    getMyAccountLog() {
      // 账单明细
      let vm = this;
      let params = {};
      params.start_date = vm.startDate;
      params.end_date = vm.endDate;
      params.type = vm.type;
      params.pay_type = vm.payType;
      params.page = vm.page;
      let loading = true;
      vm.getListFlag = false;
      vm.$post("/app/order/getMyAccountLog", params, { loading: loading }).then(
        res => {
          console.log("getMyAccountLog", res);
          vm.getListFlag = true;
          vm.listData = res.list;
          vm.totalData = res;
        }
      );
    },
    toDetail(data) {
      // 详情
      this.detailFlag = true;
      this.detail = data;
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.list-wrap {
  padding: 0 50px;
  .item-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #c9c9c9;
    cursor: pointer;
    h3 {
      font-size: 16px;
      font-weight: 500;
    }
    p {
      margin-top: 5px;
    }
    .list-l {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .icon {
        margin-right: 10px;
        width: 48px;
        height: 48px;
        // border-radius: 50%;
      }
    }
    .list-r {
      text-align: right;
    }
  }
}

.page-wrap {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  .total {
    flex: 1;
    line-height: 24px;
    display: flex;
    flex-flow: wrap;
    justify-content: flex-start;
    span {
      margin-right: 10px;
    }
  }
}
</style>
